import React from "react";
import "../App.css";
import winnerMain from "../finalist_photos/2025finals.webp";
import LazyLoad from "react-lazyload";
import Kelly from "../finalistsheadshot/kelly.webp";
import Ameya from "../finalistsheadshot/Ameyatwo.webp";
import Colin from "../finalistsheadshot/Colinding.webp";
import Cyrus from "../finalistsheadshot/Ghane.webp";
import Yanrui from "../finalistsheadshot/Yarnui.webp";
import JiaChen from "../finalistsheadshot/JiaChenQu.webp";

// Medal badge component
const MedalBadge = ({ type }) => {
  const colors = {
    gold: {
      bg: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
      text: "#7c5800",
    },
    silver: {
      bg: "linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)",
      text: "#4a4a4a",
    },
    bronze: {
      bg: "linear-gradient(135deg, #CD7F32 0%, #B87333 100%)",
      text: "#5c3a1d",
    },
  };

  return (
    <span
      style={{
        display: "inline-block",
        padding: "6px 16px",
        borderRadius: "20px",
        background: colors[type].bg,
        color: colors[type].text,
        fontSize: "0.85rem",
        fontWeight: "600",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      {type} Medal
    </span>
  );
};

// Winner card component
const WinnerCard = ({ image, name, medal, featured = false }) => (
  <div
    style={{
      background: "#fff",
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: featured
        ? "0 8px 30px rgba(0, 77, 153, 0.15)"
        : "0 4px 20px rgba(0, 0, 0, 0.06)",
      border: featured ? "2px solid #004d99" : "1px solid #e8eef3",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      cursor: "default",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-4px)";
      e.currentTarget.style.boxShadow = "0 12px 40px rgba(0, 77, 153, 0.12)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = featured
        ? "0 8px 30px rgba(0, 77, 153, 0.15)"
        : "0 4px 20px rgba(0, 0, 0, 0.06)";
    }}
  >
    <div
      style={{
        position: "relative",
        paddingTop: "120%",
        backgroundColor: "#f8f9fa",
      }}
    >
      <LazyLoad once offset={100}>
        <img
          src={image}
          alt={name}
          className="no-invert-image-partners-css"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </LazyLoad>
    </div>
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h3
        style={{
          fontSize: featured ? "1.3rem" : "1.1rem",
          fontWeight: "600",
          color: "#1a1a2e",
          marginBottom: "8px",
        }}
      >
        {name}
      </h3>
      <MedalBadge type={medal} />
    </div>
  </div>
);

function WinnersFive() {
  return (
    <div>
      {/* Hero Image */}
      <div
        style={{
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          marginBottom: "50px",
        }}
      >
        <LazyLoad once offset={100}>
          <img
            src={winnerMain}
            alt="2025 IRO Finals"
            style={{ width: "100%", display: "block" }}
          />
        </LazyLoad>
      </div>

      {/* Intro Section */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "60px",
          maxWidth: "700px",
          margin: "0 auto 60px auto",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "20px",
          }}
        >
          2025 IRO Winners
        </h2>
        <p
          style={{
            fontSize: "1.05rem",
            color: "#555",
            lineHeight: "1.8",
            marginBottom: "12px",
          }}
        >
          The 2025 International Finals took place from{" "}
          <strong>June 6th to June 8th, 2025</strong> at Harvard Square,
          Cambridge, MA.
        </p>
        <p
          style={{
            fontSize: "1rem",
            color: "#666",
            lineHeight: "1.7",
          }}
        >
          The 2025 IRO Finals showcased some of the most promising young minds
          in the world. With its dedication to critical thinking and real-world
          application of knowledge, the IRO is shaping the next generation of
          innovative leaders who will tackle global challenges and make a
          lasting impact on society.
        </p>
      </div>

      {/* Gold Medal Section */}
      <div style={{ marginBottom: "60px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            🥇
          </div>
          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "#1a1a2e",
              margin: 0,
            }}
          >
            Gold Medalist
          </h3>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "24px",
            maxWidth: "350px",
          }}
        >
          <WinnerCard
            image={Kelly}
            name="Kelly Lock"
            medal="gold"
            featured={true}
          />
        </div>
      </div>

      {/* Silver Medal Section */}
      <div style={{ marginBottom: "60px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            🥈
          </div>
          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "#1a1a2e",
              margin: 0,
            }}
          >
            Silver Medalists
          </h3>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "24px",
            maxWidth: "600px",
          }}
        >
          <WinnerCard image={Ameya} name="Ameya Kharade" medal="silver" />
          <WinnerCard image={Colin} name="Colin Yuanjie Ding" medal="silver" />
        </div>
      </div>

      {/* Bronze Medal Section */}
      <div style={{ marginBottom: "40px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              background: "linear-gradient(135deg, #CD7F32 0%, #B87333 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
            }}
          >
            🥉
          </div>
          <h3
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "#1a1a2e",
              margin: 0,
            }}
          >
            Bronze Medalists
          </h3>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "24px",
            maxWidth: "900px",
          }}
        >
          <WinnerCard image={Cyrus} name="Cyrus Ghane" medal="bronze" />
          <WinnerCard image={Yanrui} name="Yanrui Li" medal="bronze" />
          <WinnerCard image={JiaChen} name="Jia Chen Qu" medal="bronze" />
        </div>
      </div>
    </div>
  );
}

export default WinnersFive;
